import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { DropDownListModule } from "@progress/kendo-angular-dropdowns";
import { GridModule } from "@progress/kendo-angular-grid";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { PopoverModule } from "ngx-popover";
import { AutoCompleteModule } from "primeng/autocomplete";
import { GenericModalModule } from "../../../dms/layout/modals/generic-modal/generic-modal.module";
import { ModalEsaModule } from "../../../dms/layout/modals/modal-esa/modal-esa.module";
import { ModalOrdersModule } from "../../../dms/layout/modals/modal-orders/modal-orders.module";
import { ModalPhoneModule } from "../../../dms/layout/modals/modal-phone/modal-phone.module";
import { VehicleSelectModule } from "../../../dms/layout/modals/vehicle-select/vehicle-select.module";
import { VendorsDialogModule } from "../../../dms/layout/modals/vendors-dialog/vendors-dialog.module";
import { GestionTercerosService } from "../../../dms/modulos/general/componentes/gestion-terceros/gestion-terceros.service";
import { CanBeDeleteService } from "../../../dms/modulos/general/componentes/gestion-terceros/servicios/can-be-delete.service";
import { IsDeactivatedService } from "../../../dms/modulos/general/componentes/gestion-terceros/servicios/is-deactivated.service";
import { ValidateFiscalCodeService } from "../../../dms/modulos/general/componentes/gestion-terceros/servicios/validate-fiscal-code.service";
import { GestionVehiculosService } from "../../../dms/modulos/general/componentes/gestion-vehiculos/gestion-vehiculos.service";
import { DataVehiculosService } from "../../../dms/modulos/general/componentes/gestion-vehiculos/services/data-vehiculos.service";
import { AdjuntarDocumentosVehiculoService } from "../../../shared/components/adjuntar-documentos-vehiculo/adjuntar-documentos-vehiculo.service";
import { CalendarioModule } from "../../../shared/components/calendario/calendario.module";
import { ServiboxIconModule } from "../../../shared/components/servibox-icon/servibox-icon.module";
import { VehiclesModule } from "../../../shared/components/vehicles/vehicles.module";
import { PipesModule } from "../../../shared/_pipes/pipes.module";
import { CacheService } from "../../cache/cache.service";
import { HttpClientCachingService } from "../../cache/custom-http-client-caching.service";
import { DirectivesModule } from "../../directives/directives.module";
import { ButtonsActivateService } from "../../services/buttons-activate.service";
import { ORCustomerVehicleService } from "../../services/or-customer-vehicle.service";
import { InformationBoxModule } from "../InformationBox/information-box.module";
import { GestionFormComponent } from "./gestion-form.component";
import { SendDataService } from "./services/send-data.sevice";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        GenericModalModule,
        ReactiveFormsModule,
        DropDownListModule,
        LayoutModule,
        GridModule,
        DirectivesModule,
        PipesModule,
        InformationBoxModule,
        CalendarioModule,
        InputsModule,
        AutoCompleteModule,
        PopoverModule,
        ServiboxIconModule,
        ModalOrdersModule,
        VendorsDialogModule,
        ModalPhoneModule,
        VehicleSelectModule,
        VehiclesModule,
        ModalEsaModule
    ],
    declarations: [
        GestionFormComponent
    ],
    exports: [
        GestionFormComponent
    ],
    providers: [
        GestionTercerosService,
        ButtonsActivateService,
        IsDeactivatedService,
        CanBeDeleteService,
        ValidateFiscalCodeService,
        SendDataService,
        DataVehiculosService,
        HttpClientCachingService,
        CacheService,
        GestionVehiculosService,
        AdjuntarDocumentosVehiculoService,
        ORCustomerVehicleService
    ]
})
export class GestionFormModule { }
